const SIDEBAR_WIDTH = "31rem"
const PROPERTY_SELECT_WIDTH = "30rem"

export const DESKTOP_TEMPLATE_AREAS_WITH_PROPERTY_SELECT = `"constantine header select" "nav main main"`
export const DESKTOP_TEMPLATE_AREAS = `"constantine header header" "nav main main"`

export const DESKTOP_TEMPLATE_COLUMNS = `${SIDEBAR_WIDTH} 1fr ${PROPERTY_SELECT_WIDTH}`
export const DESKTOP_TEMPLATE_ROWS = "repeat(2, max-content) 1fr"

export const TABLET_TEMPLATE_AREAS_WITH_PROPERTY_SELECT = `"constantine header header" "nav select select" "nav main main"`

export const TABLET_TEMPLATE_AREAS = `"constantine header header" "nav main main"`

export const TABLET_TEMPLATE_COLUMNS = `${SIDEBAR_WIDTH} 1fr 1fr`
export const TABLET_TEMPLATE_ROWS = "repeat(2, max-content) 1fr"

export const MOBILE_TEMPLATE_AREAS_WITH_PROPERTY_SELECT = `"constantine header" "select select" "main main" "nav nav"`
export const MOBILE_TEMPLATE_AREAS = `"constantine header" "main main" "nav nav"`

export const MOBILE_TEMPLATE_COLUMNS = "max-content 1fr"
